<payee-popup title="Szolgáltatás szerkesztése">
  <form
    class="flex column"
    id="product-form"
    [formGroup]="formGroup"
  >
    <!-- Name -->
    <payee-form-field width="max">
      <span payee-label>Szolgáltatás neve</span>
      <input
        payee-input
        formControlName="name"
      />
      @if (name.invalid && name.dirty) {
        <ng-container payee-error>
          @if (name.hasError("required")) {
            <span>A mező kitöltése kötelező.</span>
          }
          @if (name.hasError("maxlength")) {
            <span>A megadott szöveg túllépi a megengedett karakterszámot.</span>
          }
        </ng-container>
      }
    </payee-form-field>
    <payee-form-field width="max">
      <span payee-label>Szolgáltatás típusa</span>
      <payee-dropdown
        width="max"
        formControlName="type"
        [options]="productTypeOptions"
      ></payee-dropdown>
    </payee-form-field>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Ügyfél országa</mat-panel-title>
        <mat-panel-description>{{ client_country_isos.controls.length }} ország</mat-panel-description>
      </mat-expansion-panel-header>
      <payee-form-field width="max">
        <span payee-label>Ország hozzáadása</span>
        <payee-autocomplete
          [formControl]="clientCountryControl"
          [options]="clientCountryOptions"
          [displayWith]="countryDisplayWith"
        ></payee-autocomplete>
      </payee-form-field>
      <div class="flex vcenter">
        <button
          type="button"
          payee-button
          height="short"
          width="short"
          (click)="addAllEuClientCountries()"
        >
          Összes EU ország hozzáadása
        </button>
        @if (client_country_isos.controls.length) {
          <button
            type="button"
            payee-button
            height="short"
            width="short"
            color="alert-red"
            (click)="removeAllClientCountries()"
          >
            Összes törlése
          </button>
        }
      </div>
      <ul>
        @for (control of client_country_isos.controls; track control; let i = $index) {
          <li class="flex vcenter">
            <span>{{ control.value?.name ?? control.value }}</span>
            <button
              payee-mini-icon-button
              color="white"
              type="button"
              (click)="removeClientCountry(i)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </li>
        }
      </ul>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Adós országa</mat-panel-title>
        <mat-panel-description>{{ debtor_country_isos.controls.length }} ország</mat-panel-description>
      </mat-expansion-panel-header>
      <payee-form-field width="max">
        <span payee-label>Ország hozzáadása</span>
        <payee-autocomplete
          [formControl]="debtorCountryControl"
          [options]="debtorCountryOptions"
          [displayWith]="countryDisplayWith"
        ></payee-autocomplete>
      </payee-form-field>
      <div class="flex vcenter">
        <button
          type="button"
          payee-button
          height="short"
          width="short"
          (click)="addAllEuDebtorCountries()"
        >
          Összes EU ország hozzáadása
        </button>
        @if (debtor_country_isos.controls.length) {
          <button
            type="button"
            payee-button
            height="short"
            width="short"
            color="alert-red"
            (click)="removeAllDebtorCountries()"
          >
            Összes törlése
          </button>
        }
      </div>
      <ul>
        @for (control of debtor_country_isos.controls; track control; let i = $index) {
          <li class="flex vcenter">
            <span>{{ control.value?.name ?? control.value }}</span>
            <button
              payee-mini-icon-button
              color="white"
              type="button"
              (click)="removeDebtorCountry(i)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </li>
        }
      </ul>
    </mat-expansion-panel>

    <!-- Law firms -->
    <payee-form-field width="max">
      <span payee-label>Ügyvédi irodák</span>
      <payee-autocomplete
        [formControl]="lawFirmControl"
        [displayWith]="dlfDisplayWith"
        [options]="defaultLawFirmOptions"
        (searchChange)="searchDefaultLawFirms$.next($event)"
      ></payee-autocomplete>
    </payee-form-field>

    <ul>
      @for (defaultLawFirm of defaultLawFirms.controls; track defaultLawFirm; let i = $index) {
        <li class="flex vcenter">
          <span>{{ defaultLawFirm.value?.name }}</span>
          <button
            payee-mini-icon-button
            color="white"
            (click)="defaultLawFirms.removeAt(i)"
          >
            <payee-icon name="trash-red"></payee-icon>
          </button>
        </li>
      }
    </ul>

    @for (feeForm of fees.controls; track feeForm; let i = $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>{{ feeForm.get("label")?.value || i + 1 + ". díj" }}</mat-panel-title>
          <mat-panel-description>
            {{ getFeePanelDescription(feeForm) }}
          </mat-panel-description>
          <button
            payee-icon-button
            color="white"
            type="button"
            [isBorderButton]="true"
            (click)="removeFee(i); $event.stopPropagation()"
          >
            <payee-icon name="trash-red"></payee-icon>
          </button>
        </mat-expansion-panel-header>
        <div [formGroup]="$any(feeForm)">
          <payee-form-field width="max">
            <span payee-label>Díj neve</span>
            <input
              payee-input
              formControlName="label"
            />
            @if (feeForm.get("label")?.invalid && feeForm.get("label")?.dirty) {
              <ng-container payee-error>
                @if (feeForm.get("label")?.hasError("required")) {
                  <span>A mező kitöltése kötelező.</span>
                }
                @if (name.hasError("maxlength")) {
                  <span>A megadott szöveg túllépi a megengedett karakterszámot.</span>
                }
              </ng-container>
            }
          </payee-form-field>
          <div class="flex">
            @if (feeForm.get("fee")?.enabled) {
              <payee-form-field width="short">
                <span payee-label>Díj mértéke</span>
                <input
                  payee-input
                  formControlName="fee"
                />
                @if (feeForm.get("fee")?.invalid && feeForm.get("fee")?.dirty) {
                  <ng-container payee-error>
                    @if (feeForm.get("fee")?.hasError("required")) {
                      <span>A mező kitöltése kötelező.</span>
                    }
                  </ng-container>
                }
              </payee-form-field>
            }
            <!-- Currency -->
            <payee-form-field width="short">
              <span payee-label>Szolgáltatás pénzneme</span>
              <payee-autocomplete
                width="short"
                formControlName="currency_iso"
                [options]="currencyOptions"
                [displayWith]="currencyDisplayWith"
              ></payee-autocomplete>
              @if (feeForm.get("currency_iso")?.value) {
                <button
                  payee-suffix
                  payee-mini-icon-button
                  color="white"
                  type="button"
                  style="pointer-events: all"
                  (click)="feeForm.get('currency_iso')?.patchValue(null)"
                >
                  <payee-icon name="trash-red"></payee-icon>
                </button>
              }
            </payee-form-field>
          </div>
          <payee-form-field width="max">
            <span payee-label>Díj típusa</span>
            <payee-dropdown
              width="max"
              formControlName="type"
              [options]="feeTypeOptions"
            ></payee-dropdown>
          </payee-form-field>
          <div class="flex">
            @if (feeForm.get("min")?.enabled) {
              <payee-form-field width="short">
                <span payee-label>Minimum díj</span>
                <input
                  payee-input
                  formControlName="min"
                />
              </payee-form-field>
            }
            @if (feeForm.get("max")?.enabled) {
              <payee-form-field width="short">
                <span payee-label>Maximum díj</span>
                <input
                  payee-input
                  formControlName="max"
                />
              </payee-form-field>
            }
          </div>
          @if (feeForm.get("is_net")?.enabled) {
            <payee-toggle
              text="Díj összege nettó"
              [selected]="feeForm.controls.is_net.value"
              (selectionChanged)="feeForm.patchValue({ is_net: $event })"
            ></payee-toggle>
          }
          <div class="flex">
            <payee-form-field width="short">
              <span payee-label>Díj behajtási ideje</span>
              <payee-dropdown
                width="short"
                formControlName="payment_occurrence"
                [options]="feePaymentOccurrenceOptions"
              ></payee-dropdown>
            </payee-form-field>
            <payee-form-field width="short">
              <span payee-label>Díj forrása</span>
              <payee-dropdown
                width="short"
                formControlName="fee_type"
                [options]="feeFeeTypeOptions"
              ></payee-dropdown>
            </payee-form-field>
          </div>
          @if (vatOptions.length > 0) {
            <payee-form-field width="max">
              <span payee-label>Díj ÁFA</span>
              <payee-autocomplete
                width="max"
                formControlName="vat_id"
                [options]="vatOptions"
                [displayWith]="vatDisplayedWith"
              ></payee-autocomplete>
            </payee-form-field>
          }
        </div>
      </mat-expansion-panel>
    }

    <button
      payee-button
      height="short"
      width="short"
      (click)="addFee()"
    >
      Díj hozzáadása
    </button>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="submitLoading"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      mat-dialog-close
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
